import React from 'react';
import { Box, Typography, Grid } from '@mui/material';
import { DetailRow } from './DetailRow';

export interface RecentRenewalsCardProps {
  data: any;
}

const RecentRenewalsCard: React.FC<RecentRenewalsCardProps> = ({ data }) => {
  if (!data) return null;

  const formatDate = (dateString: string | null) => {
    if (!dateString) return '-';
    const date = new Date(dateString);
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    const year = String(date.getFullYear()).slice(-2);
    return `${month}-${day}-${year}`;
  };

  const calculateDaysLeft = (endDate: string | null, status: string | null) => {
    if (!endDate || status === 'Renewal Completed') return '-';
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const end = new Date(endDate);
    end.setHours(0, 0, 0, 0);
    const diffDays = Math.ceil((end.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));
    return `${diffDays} Days`;
  };

  const formatRenewalStatus = (status: string | null): string => {
    if (!status) return 'Renewal Status Unknown';
    const s = status.toLowerCase().trim();
    if (['not yet tracked', 'n/a', 'renewal status unknown'].includes(s)) {
      return 'Renewal Status Unknown';
    }
    if (s === 'renewal completed') return 'Renewal Completed';
    if (s === 'renewal delayed') return 'Renewal Delayed';
    if (s === 'renewal within current month') return 'Renewal Within Current Month';
    if (s === 'decommissioned/retired') return 'Decommissioned/Retired';
    // fallback: title case
    return s.split(' ').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
  };

  const formattedStatus = formatRenewalStatus(data.trackingStatus);

  const renewalFields = [
    { label: 'Renewal End Date', value: formatDate(data.endDate), isBadge: false },
    { label: 'Renewed By', value: data.applicationOwner || '-', isBadge: false },
    { label: 'Days Left', value: calculateDaysLeft(data.endDate, data.trackingStatus), isBadge: false },
    { label: 'Renewal Status', value: formattedStatus, isBadge: true },
    { label: 'Renewal Notes', value: data.renewalNotes || '-', isBadge: false },
  ];

  return (
    <Box sx={{ background: '#ffffff', borderRadius: '8px', p: 3, height: 'calc(100% - 48px)' }}>
      <Typography sx={{ fontSize: '18px', fontWeight: 700, color: '#1b1f23', mb: 2, pb: 1 }}>
        Recent Renewal
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          {renewalFields.map((field) => (
            <DetailRow key={field.label} label={field.label} value={field.value} isBadge={field.isBadge} />
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default RecentRenewalsCard;